import { render, staticRenderFns } from "./knowledgebaseList.vue?vue&type=template&id=1ac73978&"
import script from "./knowledgebaseList.vue?vue&type=script&lang=js&"
export * from "./knowledgebaseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports